import React from 'react';
import classNames from 'classnames/bind';
import styles from './Switch.module.scss';
const cx = classNames.bind(styles);
import PropTypes from 'prop-types';
import { formLabel } from '~/utils/helpers';
import { useField } from 'formik';

//Ref: https://codepen.io/Droggy/pen/VxdWjN
function Switch({ name }) {
    const [, meta, helpers] = useField(name);

    return (
        <div className="d-flex flex-column">
            <div className="mb-2">{formLabel(name)}</div>

            <div className={cx('can-toggle')}>
                <input
                    id={name}
                    type="checkbox"
                    onChange={() => {
                        helpers.setValue(!meta.value, true); //as I set 'validateOnChange' = false, so need to specify `shouldValidate` = true so that validation can be executed upon checking the box. Ref: https://formik.org/docs/api/useField#fieldhelperprops
                    }}
                    checked={meta.value}
                />
                <label
                    htmlFor={name}
                    role="button"
                >
                    <div
                        className={cx('can-toggle__switch')}
                        data-checked="Yes"
                        data-unchecked="No"
                    ></div>
                </label>
            </div>
        </div>
    );
}

Switch.propTypes = {
    name: PropTypes.string.isRequired,
};

export default Switch;
